import axios from 'axios';
import { env } from '@config/env';
import { installInterceptors } from './interceptors';
import { refreshAuthTokens } from './authRefresh';
import { navigateTo } from '@shared/lib/navigation';
import { useAuthStore } from '@shared/stores/authStore';

/**
 * Core API client — handles SSO, domain resolution, cross-tenant identity.
 * Base URL is fixed at build time per env file; tenant headers are still
 * attached but ignored on most Core endpoints.
 */
export const coreApi = axios.create({
  baseURL: env.coreApiUrl,
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
});

installInterceptors(coreApi, {
  // Portal login proxies to the Tenant API and returns tenant-issued tokens, so
  // even Core-client 401s refresh against the regional tenant `/auth/refresh`
  // (Core has no `/portal-auth/refresh` endpoint).
  refresh: refreshAuthTokens,
  // Signed out before the redirect: while the dead token is still held, /login bounces back into the app.
  onRefreshFailed: async () => {
    await useAuthStore.getState().signOut();
    navigateTo('/login', { replace: true });
  },
});
